import { DIGITAL_PRODUCTS_FEE_PERCENTAGE } from '@fourthwall/utils/dist/constants';
import React from 'react';
import { CostItem, EstimatedFees, EstimatedProfit } from '../components/CostItem';
export const DigitalPricing = ({ includeFeesValue, digitalFeePercentage = DIGITAL_PRODUCTS_FEE_PERCENTAGE, cost, unitProfit, feesValue, }) => {
    return (React.createElement("div", null,
        React.createElement(CostItem, { name: `Hosting and server costs (${digitalFeePercentage}%)`, value: cost, negative: true }),
        includeFeesValue && React.createElement(EstimatedFees, { value: feesValue }),
        React.createElement(EstimatedProfit, { value: unitProfit })));
};
